<template>{{ usercode }} {{ zh }}欢迎来到后台管理系统</template>

<script>
export default {
  name: "WelcomeView",
  data() {
    return {
      role: sessionStorage.getItem("role"),
      usercode: sessionStorage.getItem("usercode"),
    };
  },
};
</script>
